//   document.addEventListener('DOMContentLoaded', function () {
//     const toggleBtn = document.getElementById('minicart-drawer-toggle');
//     const minicart = document.getElementById('minicart');

//     const customSelector = document.querySelector('.custom-mobile_icons #minicart-drawer-toggle');
// console.log('customSelector',customSelector);
//     if (!toggleBtn || !minicart) return;

//     toggleBtn.addEventListener('click', function (e) {
//       e.preventDefault();
//       minicart.classList.add('active');
//       console.log("clicked on cart");
//     });
//   });

document.querySelectorAll(".custom-carticon").forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();      
    });
});

document.addEventListener("click", function(e){
    if(e.target.closest("#chatty_trigger")){
        const chatty_button = document.getElementById("Avada-FAQ_WidgetTrigger")
        if(chatty_button){
            chatty_button.click();
        }
    }
})

// document.addEventListener("click", function (e) {
//   if (e.target.closest("#chatty_trigger")) {
//     const avadaTrigger = document.getElementById("Avada-FAQ_WidgetTrigger");
//     if (avadaTrigger) {
//       avadaTrigger.click();
//     }
//   }
// });
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".bh-wishlist-button");
  if (!btn) return;
    const action = btn.getAttribute("onclick");
    if (action && action.includes("removeFromWishlist")) {
        btn.classList.remove("active-wishlist");
    } else if (action && action.includes("addToWishlist_bh")) {
        btn.classList.add("active-wishlist");
    }
});



document.addEventListener("DOMContentLoaded", function () {

  function removeZip() {
    const errorEl = document.querySelector("#shippingErrors .errors");
    if (errorEl && errorEl.textContent.includes("Zip")) {
      errorEl.textContent = errorEl.textContent.replace("Zip", "").trim();
    }
  }

  removeZip();

  const observer = new MutationObserver(removeZip);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});